import React, { useState, useRef, useEffect } from "react";
import OverlayContainer from "../../../Overlay/OverlayContainer";
import ReplyModal from "./ReplyModal";
import axiosInstance from "../../../../axios";
import moment from "moment/moment";
import { getPaymentBaseurl, getS3URL } from "../../../../_helpers";
import { useSelector } from "react-redux";
import ForumReplies from "./ForumReplies";
import { Loading } from "../../../Other/Loading";
import ChapterDocument from "../../../Courses/CourseDetails/CourseChapterDetails/chapterDocument";

const PostComments = ({
  element,
  fetchUserForumPosts,
  setForumsHeaderDetails,
  studentPurchasedCourseDetails,
  setForumsInterrogate,
  forumId,
  setForumId,
}) => {
  const wrapperRef = useRef(null);
  const { REACT_APP_PAYMENT_API_BASEURL } = process.env;
  const submissionPopUpCheckmarkUrl = `https://cdn.edusity.com/icons/icon-complete-check.svg`;
  const user = useSelector((state) => state.users.user);
  const userId = user.userId || user.id[0];
  const [userShowComments, setUserShowComments] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const currentUrl = window.location.href;
  const [printCertificate, setPrintCertificate] = useState(false);
  const [cerftificateUrl, setCertificateUrl] = useState();
  const [dropList, setDropList] = useState(false);
  const [modal, setModal] = useState({ pop: false, askQuestion: false });
  const [deleteResponse, setDeleteResponse] = useState();
  const [load, setLoad] = useState(false);
  const [revulsionModalStatus, setRevulsionModalStatus] = useState();
  const [nestedRepliesCollection, setNestedRepliesCollection] = useState(null);
  const [forumsUsersRepondDetails, setForumsUsersRespondDetails] = useState();
  useOutsideAlerter(wrapperRef);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setDropList(!dropList);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const headerSelectableHandler = () => {
    setForumsHeaderDetails(`- ${element.title}`);
  };

  const postDeleteHandler = (currentIndex) => {
    axiosInstance
      .delete(`${getPaymentBaseurl(currentUrl, true)}/forum/${currentIndex}`)
      .then((res) => {
        setDeleteResponse(res.data.message);
        expungeUserRespond();
        setLoad(true);

        fetchUserForumPosts();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const expungeUserRespond = (currentIndex) => {
    setForumsInterrogate((current) =>
      current.filter((items) => items.id !== currentIndex)
    );
  };

  const getByIdRepliesCollectionHandler = (currentIdIndex) => {
    setIsLoading(true);
    axiosInstance
      .get(`${getPaymentBaseurl(currentUrl, true)}/forum/${currentIdIndex}`)
      .then((res) => {
        if (userShowComments) {
          setForumsUsersRespondDetails(res.data.data.replies);
          setIsLoading(false);
        } else {
          setUserShowComments(true);
          setForumsUsersRespondDetails(res.data.data.replies);
          setRevulsionModalStatus(null);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const userQueryActionHandler = (
    userForumsactionCurrentId,
    userForumsDetails,
    currentStageLevel,
    previousPostIndex
  ) => {
    if (userForumsactionCurrentId) {
      setRevulsionModalStatus({
        ...revulsionModalStatus,
        conceal: true,
        isEdit: true,
        forumsCourseId: userForumsDetails.courseid,
        forumsDescription: userForumsDetails.description,
        forumsTitle: userForumsDetails.title,
        currentForumsIndexId: userForumsDetails.id,
        currentState: currentStageLevel,
        previousPostId: previousPostIndex,
      });
    } else {
      setRevulsionModalStatus({
        ...revulsionModalStatus,
        conceal: true,
        isEdit: false,
        threadId: userForumsDetails?.id,
        forumsTitle: userForumsDetails.title,
        currentState: currentStageLevel,
        previousPostId: previousPostIndex,
      });
    }
  };

  const showHandler = (url) => {
    setCertificateUrl(url);
    setPrintCertificate(!printCertificate);
  };

  return (
    <>
      <div
        className="box-shadow-new-01 comment-margin-b"
        onClick={headerSelectableHandler}
      >
        <div className="forum-heading-1">
          <div className="forum-heading">
            <div class="user-avatar navbar-profile">
              {element?.profileImage && (
                <img alt="profile" src={getS3URL(element?.profileImage)} />
              )}
            </div>
            <div className="forum-student">
              <h6>
                {element?.firstName} {element?.lastName} -
              </h6>
            </div>
            <div className="student-profile">
              <h6>{element?.title}</h6>
            </div>
          </div>
          <div>
            <p className="time-style">
              {moment(element?.time).format("MM/DD/YYYY")}
            </p>
          </div>

          {element.userId === userId && (
            <div
              className="list-edit"
              onClick={() =>
                setDropList({ ...dropList, question: !dropList.question })
              }
            >
              <ul>
                <li></li>
                <li></li>
                <li></li>
              </ul>
              {dropList.question && (
                <div className="edit-delete-drop" ref={wrapperRef}>
                  {!element.replies > 0 && (
                    <li
                      className="Edit-btn-post item"
                      onClick={() => userQueryActionHandler(true, element)}
                    >
                      Edit
                    </li>
                  )}

                  <li
                    className="Edit-btn-post item"
                    onClick={() => postDeleteHandler(element.id)}
                  >
                    Delete
                  </li>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="post-comment">
          <p>{element?.description}</p>
          <div className="post-forum-images">
            {element.files[0].map((file, key) => {
              return (
                <div>
                  {file?.fileName.includes(".pdf") ? (
                    <span onClick={() => showHandler(getS3URL(file.objectKey))}>
                      {file.fileName}
                    </span>
                  ) : file?.fileName.includes(".mp4") ? (
                    <video src={getS3URL(file.objectKey)} alt="forum-video" />
                  ) : (
                    <img src={getS3URL(file.objectKey)} alt="forum-image" />
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className="reply-box">
          <div className="forum-heading">
            {element.replies > 0 && (
              <p
                onClick={() =>
                  forumsUsersRepondDetails?.length > 0
                    ? setUserShowComments(!userShowComments)
                    : getByIdRepliesCollectionHandler(element.id)
                }
              >
                {element.replies} comments
              </p>
            )}

            <button
              onClick={() =>
                userQueryActionHandler(false, element, "levelZero")
              }
            >
              Reply
            </button>
          </div>
        </div>
        {userShowComments && (
          <>
            <div className="sub-commentbox">
              {forumsUsersRepondDetails &&
                forumsUsersRepondDetails.length > 0 &&
                forumsUsersRepondDetails.map((commnetsdata, index) => (
                  <ForumReplies
                    commnetsdata={commnetsdata}
                    index={index}
                    userId={userId}
                    userQueryActionHandler={userQueryActionHandler}
                    setDeleteResponse={setDeleteResponse}
                    getByIdRepliesCollectionHandlers={
                      getByIdRepliesCollectionHandler
                    }
                    setLoad={setLoad}
                    previousPostIndex={element.id}
                    nestedRepliesCollection={nestedRepliesCollection}
                    setForumsUsersRespondDetails={setForumsUsersRespondDetails}
                    fetchUserForumPosts={fetchUserForumPosts}
                  />
                ))}
            </div>
          </>
        )}
        {isLoading && <Loading />}

        {load && (
          <OverlayContainer>
            <div className="forms-width-reply add-reply">
              <div className="submission_PopUp">
                <div className="preview-close" onClick={() => setLoad(!load)}>
                  <div>
                    <i className="icon check"></i>
                  </div>
                </div>
                <div className="item-popup-text">
                  <img
                    src={submissionPopUpCheckmarkUrl}
                    alt="Image Not Found"
                  />
                  <p>{deleteResponse}</p>
                </div>
              </div>
            </div>
          </OverlayContainer>
        )}

        {revulsionModalStatus?.conceal && (
          <OverlayContainer>
            <ReplyModal
              revulsionModalStatus={revulsionModalStatus}
              setRevulsionModalStatus={setRevulsionModalStatus}
              getByIdRepliesCollectionHandler={getByIdRepliesCollectionHandler}
              setModal={setModal}
              modal={modal}
              forumId={forumId}
              setForumId={setForumId}
              cId={element.courseid}
              fetchUserForumPosts={fetchUserForumPosts}
              title={element.title}
              setNestedRepliesCollection={setNestedRepliesCollection}
              studentPurchasedCourseDetails={studentPurchasedCourseDetails}
            />
          </OverlayContainer>
        )}
      </div>
      {printCertificate && (
        <OverlayContainer>
          <ChapterDocument
            type={"pdf"}
            url={cerftificateUrl}
            closeHandler={showHandler}
            show={printCertificate}
          />
        </OverlayContainer>
      )}
    </>
  );
};
export default PostComments;
